import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class MixService {

  private mixSource = new BehaviorSubject<string>("");
  currentMixId = this.mixSource.asObservable();

  constructor() { }

  changeMix(mix_id: string) {
    this.mixSource.next(mix_id)
  }

}



// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/mix-service.service.ts